const initialState = {
  isFetching: false,
  isFetched: false,
  page: 1,
  items: 10,
  total: 0,
  list: [],
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case 'MARKETPLACE/PROFILE_ADS_REQUEST':
      return { ...state, isFetching: true, isFetched: false };
    case 'MARKETPLACE/PROFILE_ADS_FAILURE':
      return { ...state, isFetching: false, isFetched: false };
    case 'MARKETPLACE/PROFILE_ADS_SUCCESS':
      return { ...state, isFetching: false, isFetched: true, page: payload.page, total: payload.total, list: [...payload.marketplaces] };

    case 'MARKETPLACE/DELETE_ITEM_REQUEST':
      return { ...state, isFetching: true, isFetched: false };
    case 'MARKETPLACE/DELETE_ITEM_FAILURE':
      return { ...state, isFetching: false, isFetched: false };
    case 'MARKETPLACE/DELETE_ITEM_SUCCESS':
      const newList = state.list.filter(item => item.id !== payload.id);
      return { ...state, isFetching: false, isFetched: true, list: [...newList], total: state.total - 1, };

    case 'MARKETPLACE/RESET':
    case 'MARKETPLACE/RESET_CATALOG':
      return initialState;
    default:
      return state;
  };
};

export default reducer;